import $ from "jquery"


class R2D2{

    Wrap
    ResultatsWrap = "#resultats"
    BtnNext = "#btn_next"
    BtnPrev = "#btn_prev"
    BtnRefresh = "#btn_refresh"
    BtnDone = "#btn_done"

    TunnelWrap = "#tunnel-wrap"   
    Tunnel = {
        item : `<div class="tunnel-item flex items-center gap-4" data-target="">
                    <span class="tunnel-item-figure flex items-center justify-center text-sm bg-pearl rounded-full w-[35px] h-[35px] font-semibold"></span>
                    <span class="tunnel-item-text font-semibold"></span>
                </div>`,

        sep : `<span class="material-symbols-rounded">chevron_right</span>`
    }
    Card = `<article class="shadow-lg rounded-lg overflow-hidden relative group">
                <div>
                    <div class="overflow-hidden thumbnail"> 
                    </div> 
                    <div class="p-8 mb-24">
                        <a href="" class="permalink">
                            <h4 class="mb-3 title"></h4>
                            <span class="absolute inset-0"></span>
                        </a>
                        <p class="leading-5 mb-3 excerpt"></p>
                        <div class="btn-selection text-center absolute bottom-8 left-0 right-0 z-10 px-8"></div>
                    </div>
                </div>                
            </article>`

    NoResTpl = `<div>
        <h5 class="text-xl font-bold mb-12">Je vous propose plusieurs solutions :</h5>
        <ul>
            <li class="mb-4">Essayez de revenir en arrière pour diversifier / assouplir vos critères<br>
            <span class="text-sm text-gray">Relancez une recherche ou utilisez le menu</span></li>
            <li class="mb-4">Contacter un conseiller qui comprendra votre besoin et vous proposera des profils adaptés<br>
            <span class="text-sm text-gray">Demandez à être recontacté via le formulaire ci-dessous, ou <a href="/ma-selection/" class="text-blue-light font-bold">soumettez votre demande</a> sans préciser de profil</span></li>
            <li class="mb-4"><a href="/catalogue/" class="text-blue-light font-bold">Consultez notre catalogue</a> afin d'avoir une vision plus globale de notre éventail de personalités</li>
        </ul>
    </div>`

    Step = 0

    Data = {
        thematics : null,
        jobs : null,
        meta : {
            isEnglish : '',
            genre : '',
            type : ''
        }
    }

    

    constructor ( wrap ) {

        this.Wrap = $( wrap )

        this.initTunnel()

        this.Wrap.on( 'click' , '.card' , e => {
            this.clickCard( $(e.currentTarget) )
        })

        this.Wrap.on( 'click' , '.item-specs' , e => {
            this.clickItem( $(e.currentTarget) )
        })

        this.Wrap.on( 'click' , '.accordion-button' , e => {
            this.clearAllData()
            this.Wrap.find('.card').removeClass( 'active' )  
            this.Wrap.find('.to-show').addClass( 'hidden' )  
        })

        this.Wrap.on( 'click' , this.BtnNext , e => {            
            this.scrollTop()
            this.clickNext()
        })

        this.Wrap.on( 'click' , this.BtnPrev , e => {            
            this.scrollTop()
            this.clickPrev()
        })

        this.Wrap.on( 'click' , this.BtnRefresh , e => {            
            this.scrollTop()
            this.clickRefresh()
        })

        this.Wrap.on( 'click' , '.accordion-button' , e => {
            this.Data.meta[ $(e.currentTarget).attr( 'data-key' ) ] =  $(e.currentTarget).attr( 'data-value' )   
            console.log( this.Data ) 
        })

        $(this.TunnelWrap).on( 'click' , '.clickable' , e => {                        
            this.clickTunnelItem( $(e.currentTarget) )
        })

        $( 'input[type=radio]' ).on( 'change' , e => {  
            this.Data.meta[ $(e.currentTarget).attr( 'name' ) ] =  $(e.currentTarget).val()          
            console.log( this.Data.meta )
        })

    }


    initTunnel () {

        const tunnelWrap = $(this.TunnelWrap)

        tunnelWrap.empty()

        this.Wrap.find( '.slide:not(.disable)' ).each( ( index , element ) => {    

            tunnelWrap.append( this.Tunnel.item )
            let tunnelItem = tunnelWrap.find( '.tunnel-item:eq('+ index +')' )
            tunnelItem.attr( 'data-target' , $(element).attr( 'id' ) ).find( '.tunnel-item-text' ).html( $(element).attr( 'data-menu' ) )
            tunnelItem.find( '.tunnel-item-figure' ).html( index + 1 )

            if( index < this.Step ){
                tunnelItem.addClass( 'clickable' )
            }else if( index === this.Step ){
                tunnelItem.addClass( 'active' )
            }else{
                tunnelItem.addClass( 'disable' )
            }

        })
    
    }

    scrollTop () {
        $('html, body').animate({
            scrollTop: this.Wrap.offset().top - 30
        }, 200);
    }


    clickCard ( target ) {

        $( '.slide' ).removeClass( 'disable' )
        this.initTunnel()

        // DECOCHAGE
        if( target.hasClass( 'active' ) ){

            target.removeClass( 'active' )    
            this.Wrap.find( target.attr('data-show') ).addClass( 'hidden' )
            this.removeData( target.attr('data-key') , target.attr('data-value') )

        // COCHAGE
        }else{

            if( ! target.attr( 'data-multiple' ) ){
                this.clearAllData( target.attr('data-key') )  
                this.Wrap.find( '.card' ).removeClass( 'active' )
            }

            target.addClass( 'active' )
            this.addData( target.attr('data-key') , target.attr('data-value') )

            this.Wrap.find( '.to-show' ).addClass( 'hidden' )
            let show = target.attr( 'data-show' )
            this.Wrap.find( show ).removeClass( 'hidden' )

            if( target.attr( 'data-disabled' ) ){
                $( target.attr( 'data-disabled' ) ).addClass( 'disable' )
                this.initTunnel()
            }

        }
    }



    clickItem ( target ) {

        $( '.slide' ).removeClass( 'disable' )
        this.initTunnel()
        
        // DECOCHAGE
        if( target.hasClass( 'active' ) ){
            target.removeClass( 'active' )      
            this.removeData( target.attr('data-key') , target.attr('data-value') )

        // COCHAGE
        }else{
            target.removeClass( 'active' )
            target.addClass( 'active' )
            this.addData( target.attr('data-key') , target.attr('data-value') )

            if( target.attr( 'data-disabled' ) ){
                $( target.attr( 'data-disabled' ) ).addClass( 'disable' )
                this.initTunnel()
            }
        }

    }


    addData ( key , val ){
        
        if( Array.isArray( this.Data[ key ] ) ){
            if( ! this.Data[ key ].includes( val ) ){
                this.Data[ key ].push( val )
            }
        }else{            
            this.Data[ key ] = [val]
        }

        // Activer bouton suivant
        this.enableBtn( this.BtnNext )

        console.log( this.Data.jobs , this.Data.thematics )

    }


    removeData ( key , val ){

        let searchIndex = this.Data[ key ].findIndex( element => element === val )
        
        if( searchIndex >= 0 ){     
            if( this.Data[ key ].length === 1 ){
                this.Data[ key ] = null

                this.disableBtn( this.BtnNext )
            }else{
                this.Data[ key ].splice( searchIndex , 1 )
            }
        }

        console.log( this.Data.jobs , this.Data.thematics )

    }

    clearAllData ( key = false ){
        
        if( !key ){

            this.Data.jobs = null    
            this.Data.thematics = null 
            this.Wrap.find('.item-specs').removeClass( 'active' )

        }else if( key === 'jobs' ){

            this.Data.jobs = null

        }else if( key === 'thematics' ){

            this.Data.thematics = null 
            this.Wrap.find('.item-specs').removeClass( 'active' )

        }
        
        this.disableBtn( this.BtnNext ) 

        console.log( this.Data.jobs , this.Data.thematics )
        
    }


    enableBtn ( target ) {

        $(target).removeClass( '!hidden' )
        if( this.Data.jobs !== null || this.Data.thematics !== null ){            
            $(target).attr( 'disabled' , false )
        }else{
            $(target).attr( 'disabled' , true )
        }
        
    }


    disableBtn ( target , hide = false ) {
        if( hide ){
            $(target).addClass( '!hidden' )
        }else{
            $(target).attr( 'disabled' , true );
        }
    }

    clickNext () {        
        this.Step ++
        this.updateSlide()
        this.updateTunnel()
    }

    clickPrev() {        
        this.Step --
        this.updateSlide()
        this.updateTunnel()
    }

    clickRefresh() {        
        this.Step = 0
        this.Data = {
            thematics : null,
            jobs : null,
            meta : {
                isEnglish : '',
                genre : '',
                type : ''
            }
        }
        this.updateSlide()
        this.updateTunnel()
        this.disableBtn( this.BtnDone , true )
        this.disableBtn( this.BtnRefresh , true )
        this.enableBtn( this.BtnNext )
        this.enableBtn( this.BtnPrev )
        $('.accordion-collapse').removeClass('show')
        $('.card').removeClass('active')
        $('.item-specs').removeClass('active')
    }

    clickTunnelItem ( elt ) {
        this.Step = elt.index()
        this.updateSlide() 
        this.updateTunnel()  
        this.disableBtn( this.BtnRefresh , true )
        this.disableBtn( this.BtnDone , true )
    }

    updateSlide () {

        this.Wrap.find('.slide').addClass( 'hidden' )
        this.Wrap.find('.slide:not(.disable):eq('+ this.Step  +')').removeClass( 'hidden' )  
        if( this.Step === 0 ){
            this.disableBtn ( this.BtnPrev )
        }else{
            this.enableBtn ( this.BtnPrev )
        }

        this.enableBtn ( this.BtnNext )

        if( this.Wrap.find('.slide:not(.disable)').length - 1 === this.Step ){
            this.results()
        }
    }

    updateTunnel () {

        for( let index = 0 ; index < $(this.TunnelWrap).find( '.tunnel-item' ).length ; index++ ){

            let tunnelItem = $(this.TunnelWrap).find( '.tunnel-item:eq('+ index +')' ) 
            tunnelItem.removeClass( 'active' ).removeClass( 'disable').removeClass( 'clickable' )

            if( index < this.Step ){                
                tunnelItem.addClass( 'clickable' )
            }else if( index === this.Step ){
                tunnelItem.addClass( 'active' )
            }else{
                tunnelItem.addClass( 'disable' )
            }

        }
    }


    results () {

        this.disableBtn( this.BtnNext , true )
        this.disableBtn( this.BtnPrev , true )

        $( '#resultats-content' ).html( '' )

        $.ajax({
            url : adminAjax,
            method : 'POST',
            data : {
                action : 'r2d2',
                data : this.Data
            },
                
            success : ( res ) => {

                let data = res.data

                // 1 ou plusieurs résultats trouvés
                if( data ){

                    switch( data.length ){
                        case 1:
                            $( '#resultats-title' ).html( "J'ai trouvé 1 résultat !<div class='block text-lg text-gray py-4'>Contactez un conseiller pour voir si d'autres résultats sont possibles</div>" );
                            break;
                        case 2:
                            $( '#resultats-title' ).html( "J'ai trouvé 2 résultats !<div class='block text-lg text-gray py-4'>Contactez un conseiller pour voir si d'autres résultats sont possibles</div>" );
                            break;
                        default:
                            $( '#resultats-title' ).html( "J'ai sélectionné 3 résultats !<div class='block text-lg text-gray py-4'>Contactez un conseiller pour voir si d'autres résultats sont possibles</div>" );
                            break;
                    }

                    $( '#resultats-content' ).html( '<div class="resultats-posts grid grid-cols-1 gap-12 md:grid-cols-2 xl:grid-cols-3"></div>' )

                    for( let post of data ){
                        $( '#resultats-content .resultats-posts' ).append( this.Card )
                        let current = $( '#resultats-content .resultats-posts article:last-child' )
                        current.find( '.title' ).html( post.title )
                        current.find( '.excerpt' ).html( post.excerpt )
                        current.find( '.permalink' ).attr( 'href' , post.permalink )
                        current.find( '.thumbnail' ).html( post.thumbnail )
                        current.find( '.btn-selection' ).html( post.btn )
                    }

                // Aucun resulats de recherche
                }else{

                    $( '#resultats-title' ).text( "Je n'ai trouvé aucun profil correspondant à vos critères" );
                    $( '#resultats-content' ).html( this.NoResTpl )

                }

                this.enableBtn( this.BtnRefresh )
                this.enableBtn( this.BtnDone )

            },

            error : ( error ) => {
                
            }
        });  

    }
}

const r2d2 = new R2D2( '#r2d2' );